import { useCallback, useState } from 'react';
import { INITIAL_UI_STATES, getUiState, uiStatusOf, nowStr } from './uiDesignMock';

/**
 * UI 设计确认状态（列表页 / 详情页共用）
 * 返回：
 * - uiStates：{ [projectId]: { versions: [...] } }
 * - getState(id)：取某项目 UI 设计状态
 * - getStatus(id)：取当前状态（none / pending / confirmed / rejected）
 * - upload(id, { screens, note })：上传 / 替换 → 生成新版本并回到「待确认」
 * - confirm(id)：客户确认通过
 * - reject(id, reason)：客户驳回（必填理由）
 */
export const useUIDesign = () => {
    const [uiStates, setUiStates] = useState(() => ({ ...INITIAL_UI_STATES }));

    const getState = useCallback((id) => getUiState(uiStates, id), [uiStates]);
    const getStatus = useCallback((id) => uiStatusOf(getUiState(uiStates, id)), [uiStates]);

    const upload = useCallback((id, { screens, note }) => {
        setUiStates((prev) => {
            const cur = getUiState(prev, id);
            const versions = cur.versions || [];
            const record = {
                version: versions.length + 1,
                screens: screens || [],
                note: note || '',
                uploadedAt: nowStr(),
                uploadedBy: '平台客服',
                result: 'pending',
            };
            return { ...prev, [id]: { versions: [...versions, record] } };
        });
    }, []);

    const confirm = useCallback((id) => {
        setUiStates((prev) => {
            const cur = getUiState(prev, id);
            const versions = [...(cur.versions || [])];
            if (!versions.length) return prev;
            versions[versions.length - 1] = { ...versions[versions.length - 1], result: 'confirmed', confirmedAt: nowStr() };
            return { ...prev, [id]: { versions } };
        });
    }, []);

    const reject = useCallback((id, reason) => {
        setUiStates((prev) => {
            const cur = getUiState(prev, id);
            const versions = [...(cur.versions || [])];
            if (!versions.length) return prev;
            versions[versions.length - 1] = { ...versions[versions.length - 1], result: 'rejected', rejectReason: reason, confirmedAt: nowStr() };
            return { ...prev, [id]: { versions } };
        });
    }, []);

    return { uiStates, getState, getStatus, upload, confirm, reject };
};

export default useUIDesign;
